module.exports = __webpack_public_path__ + "static/media/PALM.9079a305.png";